const ET = new Intl.DateTimeFormat('en-US', {
  timeZone: 'America/New_York',
  year: 'numeric',
  month: 'short',
  day: 'numeric',
  hour: 'numeric',
  minute: '2-digit',
  timeZoneName: 'short',
});

const UNITS: [label: string, seconds: number][] = [
  ['d', 86_400],
  ['h', 3_600],
  ['m', 60],
];

/** "Oct 30, 2026, 4:10 PM EDT" for an ISO timestamp. */
export const formatEt = (iso: string) => ET.format(new Date(iso));

/** "5m ago", "3h ago", "2d ago"; "just now" under a minute. */
export function relativeAge(iso: string, now: number = Date.now()): string {
  const seconds = Math.max(
    0,
    Math.floor((now - new Date(iso).getTime()) / 1000),
  );
  const unit = UNITS.find(([, size]) => seconds >= size);
  return unit ? `${Math.floor(seconds / unit[1])}${unit[0]} ago` : 'just now';
}
